import '.bm{flex-shrink:0;}.ssr-plugin'
import '.bo{padding:1rem;}.ssr-plugin'
import '.a1{width:100%;}.ssr-plugin'
import '.bf{height:100%;}.ssr-plugin'
import '.b4{border:none;}.ssr-plugin'
import '.b5{background-color:transparent;}.ssr-plugin'
import '.ed{border-radius:0px;}.ssr-plugin'
import '.a{display:flex;}.ssr-plugin'
import '.e{flex-direction:column;}.ssr-plugin'
import '.a6{align-items:stretch;}.ssr-plugin'
import '.dr{position:sticky;}.ssr-plugin'
import '.ee{top:4rem;}.ssr-plugin'
import '.ef{z-index:7;}.ssr-plugin'
import '.a9{background-color:var(--shades-white);}.ssr-plugin'
import '.eg{padding-bottom:1rem;}.ssr-plugin'
import '.v{margin-bottom:1rem;}.ssr-plugin'
import '.eh{border-bottom:var(--blue-border);}.ssr-plugin'
import '.s{position:fixed;}.ssr-plugin'
import '.d4{top:0;}.ssr-plugin'
import '.bd{left:0px;}.ssr-plugin'
import '.be{right:0px;}.ssr-plugin'
import '.ei{bottom:0px;}.ssr-plugin'
import '.ej{z-index:9999;}.ssr-plugin'
import '.ek{transition:transform 0.3s ease-in-out;}.ssr-plugin'
import '.co{justify-content:flex-end;}.ssr-plugin'
import '.bz{flex:1;}.ssr-plugin'
import '.an{overflow-y:auto;}.ssr-plugin'
import { Style, styled } from 'inlines'
import {
  isValidElement,
  PropsWithChildren,
  ReactNode,
  useState,
  useEffect,
} from 'react'
import { useLocation } from 'wouter'
import { Button } from '@app/components/core/button/Button'
import { CloseButton } from '@app/components/core/button/CloseButton'

interface LeftSidebarMobileProps {
  sidebar: ReactNode
  content: ReactNode[]
}

const Sidebar = ({
  children,
  style,
}: PropsWithChildren & { style?: Style }) => {
  return (
    <styled.aside className="bm bo a1 bf b4 b5 ed"
      style={{
        ...style,
      }}
    >
      {children}
    </styled.aside>
  )
}

export const LeftSidebarMobile = ({
  sidebar,
  content,
}: LeftSidebarMobileProps) => {
  const [isOpen, setIsOpen] = useState(false)
  const [location] = useLocation()

  // Close sidebar when route changes
  useEffect(() => {
    setIsOpen(false)
  }, [location])

  const collapsedButtonLabel =
    (isValidElement(sidebar) && sidebar.props.collapsedButtonLabel) || 'Menu'

  const sidebarContent = isValidElement(sidebar) ? sidebar.props.children : null
  const sidebarStyle = isValidElement(sidebar) ? sidebar.props.style : undefined

  return (
    <div className="a e a6"
    >
      <div className="dr ee ef a9 eg v eh a"
      >
        <Button
          variant="link"
          label={collapsedButtonLabel}
          onClick={() => setIsOpen(true)}
        />
      </div>

      <div className="s d4 bd be ei ej a9 ek a e"
        style={{
          transform: isOpen ? 'translateX(0)' : 'translateX(-100%)',}}
      >
        <div className="bo a co eh"
        >
          <CloseButton onClick={() => setIsOpen(false)} />
        </div>
        <div className="bz an">
          <Sidebar style={sidebarStyle}>{sidebarContent}</Sidebar>
        </div>
      </div>

      {content}
    </div>
  )
}
